import { useState, useContext } from "react";
import { useNavigate, Navigate } from "react-router-dom";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import { auth } from "../../../firebase.config";
import { signInWithEmailAndPassword } from "firebase/auth";
import { AuthContext } from "../../../Auth";

export const Login = () => {
  const [user, setUser] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleLogin = () => {
    signInWithEmailAndPassword(auth, user.email, user.password)
      .then((userCredential) => {
        setError("");
        setUser({ email: "", password: "" });
        navigate("/admin");
      })
      .catch((error) => {
        setError(error.message);
      });
  };

  const { currentUser } = useContext(AuthContext);

  if (currentUser) {
    return <Navigate to="/admin" />;
  }

  return (
    <Box
      sx={{
        width: "100vw",
        paddingTop: "3rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1.5rem",
      }}
    >
      <Typography variant="h4">Prijava</Typography>
      <TextField
        id="email"
        label="Email"
        variant="outlined"
        value={user.email}
        sx={{ width: "400px", maxWidth: "80%" }}
        onChange={(e) => setUser({ ...user, email: e.target.value })}
      />
      <TextField
        id="password"
        label="Lozinka"
        type="password"
        variant="outlined"
        value={user.password}
        sx={{ width: "400px", maxWidth: "80%" }}
        onChange={(e) => setUser({ ...user, password: e.target.value })}
      />
      {!!error.length && (
        <Typography variant="body2" sx={{ color: "red" }}>
          {error}
        </Typography>
      )}
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#F1B317",
          color: "#595959",
          "&:hover": {
            backgroundColor: "#F1B317",
            color: "white",
          },
        }}
        onClick={handleLogin}
      >
        Login
      </Button>
    </Box>
  );
};
